import { ColDef } from "ag-grid-community";

export const NUMERIC_COL_DEF: ColDef | any = {
	type: "numericColumn", // cellClass: "ag-numeric-cell"
	headerClass: null, // override ag-numeric-header
	cellClass: "ag-numeric-cell",
	filter: "agNumberColumnFilter",
	enableValue: true,
	fieldType: "number",
	isInteger: true,
};
